var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRawDataLinkIcon = function SvgRawDataLinkIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rawDataLinkIcon_svg__a)",
    d: "M10.4 6.667a2.333 2.333 0 1 1-4.667 0 2.333 2.333 0 0 1 4.667 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rawDataLinkIcon_svg__b)",
    fillRule: "evenodd",
    d: "M12.645 13.965a7.467 7.467 0 1 1 1.32-1.32l3.162 3.162a.933.933 0 1 1-1.32 1.32zm-8.099-1.543a3.735 3.735 0 0 1 7.042 0 5.6 5.6 0 1 0-7.041 0",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "rawDataLinkIcon_svg__a",
    x1: 6.06,
    x2: -76.45,
    y1: 36.3,
    y2: -26.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--color-icons-bg)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--color-icons-bg)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rawDataLinkIcon_svg__b",
    x1: 6.06,
    x2: -76.45,
    y1: 36.3,
    y2: -26.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--color-icons-bg)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--color-icons-bg)"
  })))));
};
export default SvgRawDataLinkIcon;